/**
 * Created by Amir Absaliamov on 03.09.2026
 */

class MistakesLikePraiseAdapter {
    constructor(sceneNode) {
        this.sceneNode = sceneNode;
        this.styles = cleverapps.styles.MistakesLikePraiseAdapter;
        this.tutorial = MistakesLikePraiseAdapter.TUTORIAL;
    }

    get anchor() {
        return cleverapps.resolution.isVertical() ? cc.p(0.5, 1) : cc.p(1, 1);
    }

    getWorldPosition() {
        const panel = cleverapps.aims.getTarget("mistakes", { noDefault: true });

        if (panel) {
            const box = panel.getGlobalBoundingBox();
            const vertical = cleverapps.resolution.isVertical();
            const style = vertical ? this.styles.portrait : this.styles.landscape;

            if (vertical) {
                return cc.p(box.x + box.width / 2, box.y - style.gap + style.dy);
            }
            return cc.p(box.x - style.gap, box.y + box.height + style.dy);
        }

        if (!this.sceneNode || !this.sceneNode.isRunning()) {
            return undefined;
        }

        const fallback = this.styles.fallback[cleverapps.resolution.mode];
        return this.sceneNode.convertToWorldSpace(cc.p(
            this.sceneNode.width / 2 + fallback.dx,
            this.sceneNode.height + fallback.dy
        ));
    }
}

MistakesLikePraiseAdapter.TUTORIAL = "first";

cleverapps.styles.MistakesLikePraiseAdapter = {
    landscape: { gap: 125, dy: -50 },
    portrait: { gap: 20, dy: 0 },

    fallback: [
        { dx: 0, dy: -175 },
        { dx: -210, dy: -30 },
        { dx: -210, dy: -40 }
    ]
};
